import { render } from "./SocietyCardSection.vue?vue&type=template&id=2b847a30"
import script from "./SocietyCardSection.vue?vue&type=script&lang=js"
export * from "./SocietyCardSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__